import { render, staticRenderFns } from "./DynamicDetail.vue?vue&type=template&id=3e892198&scoped=true"
import script from "./DynamicDetail.vue?vue&type=script&lang=js"
export * from "./DynamicDetail.vue?vue&type=script&lang=js"
import style0 from "./DynamicDetail.vue?vue&type=style&index=0&id=3e892198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e892198",
  null
  
)

export default component.exports